export default "__VITE_ASSET__889cecf4__"